import { useCallback } from 'react';

import { useSettings } from '@/data/Settings';
import { getExternalId } from '@/data/utils/externalId';
import { FacebookClientPayload } from '@/pages/api/tracking/facebook/facebookAPIUtils';
import { useFacebookClickIdentifiers } from 'presentation/events/hooks/useClickIdentifiers';
import { useTrackingStoreLocation } from 'presentation/events/hooks/useTrackingStoreLocation';
import { triggerFacebookCAPIEvent } from 'presentation/events/services/facebookService';

import { SendMediaEventProps } from './types';

export const useTrackPageViewFacebook = () => {
	const { settings } = useSettings();
	const { userData } = settings;
	const { fbc, fbp } = useFacebookClickIdentifiers();
	const storeLocation = useTrackingStoreLocation();

	const sendFacebookEvent = useCallback(
		({ eventId, personInfo, storeId }: SendMediaEventProps) => {
			if (userData?.ENABLE_CAPI_TARGET_CALL !== 'true') return;

			const facebookPayload: FacebookClientPayload = {
				event_name: 'PageView',
				event_id: eventId,
				storeId,
				event_source_url: decodeURI(window.location.href),
				fbc,
				fbp,
				test_event_code: userData.FACEBOOK_TEST_CODE,
				custom_data: {
					externalId: getExternalId(),
					email: personInfo?.email,
					firstName: personInfo?.firstName,
					lastName: personInfo?.lastName,
					city: storeLocation?.city,
					phone: personInfo?.phone,
					state: storeLocation?.state,
					zipCode: storeLocation?.zipCode,
				},
			};

			triggerFacebookCAPIEvent(facebookPayload);
		},
		[fbc, fbp, storeLocation, userData?.ENABLE_CAPI_TARGET_CALL, userData.FACEBOOK_TEST_CODE]
	);

	return { sendFacebookEvent };
};
